function openTab(evt, tabId) {
  const section = evt.currentTarget.closest(".mh_section");
  if (!section) return;

  const contents = section.querySelectorAll(".tab-content_mh");
  const buttons = section.querySelectorAll(".tab-button_mh");

  contents.forEach(c => c.classList.remove("active_mh"));

  buttons.forEach(b => {
    b.classList.remove("active_mh");
    b.setAttribute("aria-selected", "false");
  });

  const activeTab = section.querySelector(`#${tabId}`);
  if (activeTab) {
    activeTab.classList.add("active_mh");
  }

  evt.currentTarget.classList.add("active_mh");
  evt.currentTarget.setAttribute("aria-selected", "true");
}

// MODAL
function openModal(id, el) {
  const section = el.closest(".mh_section");
  if (!section) return;

  const modal = section.querySelector(`#${id}`);
  if (modal) modal.classList.add("show_mh");
}

function closeModal(id, el) {
  const section = el.closest(".mh_section");
  if (!section) return;

  const modal = section.querySelector(`#${id}`);
  if (modal) modal.classList.remove("show_mh");
}

document.addEventListener("click", function(e) {
  if (e.target.classList.contains("modal_mh")) {
    e.target.classList.remove("show_mh");
  }
});